<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
    <g transform="translate(-23 -269)">
      <g transform="translate(2 33)">
        <path class="a" d="M15,21H5a2,2,0,0,1-2-2V5A2,2,0,0,1,5,3H15" transform="translate(19 234)"/>
        <path class="a" d="M21,17l-5-5,5-5" transform="translate(12 234)"/>
        <line class="a" x2="12" transform="translate(28 246)"/>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'EntryIcon'
}
</script>

<style scoped>
.a {
  fill: none;
  stroke: #fff;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2px;
}
</style>
